import { useQuery } from "@tanstack/react-query";
import adminApiClient, { AffiliateClockStats } from "../../api/admin";

export type AffiliateClockRange =
  | { days: number }
  | { from: string; to: string };

const useAffiliateClockStats = (range: AffiliateClockRange) => {
  return useQuery<AffiliateClockStats>({
    queryKey: ["affiliateClockStats", range],
    queryFn: () => adminApiClient.getAffiliateClockStats(range),
  });
};

export default useAffiliateClockStats;
